import React from 'react';

const LeadSelect = ({ lead, handleChange }) => {
    return (
        <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="branch">
                Branch
            </label>
            <select
                id="00NHo00000Y1GDa"
                name="00NHo00000Y1GDa"
                value={lead}
                onChange={handleChange}
                className="block appearance-none w-full bg-white border hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                required
            >
                <option value="">Please Select</option>
                <option value="Army Navy Game">Army Navy Game</option>
                <option value="Benefits.com">Benefits.com</option>
                <option value="Bing">Bing</option>
                <option value="Facebook">Facebook</option>
                <option value="Fellow Veteran">Fellow Veteran</option>
                <option value="Friends/Family">Friends/Family</option>
                <option value="Google">Google</option>
                <option value="Hire GI">Hire GI</option>
                <option value="Irreverent Warriors">Irreverent Warriors</option>
                <option value="Kline Veterans Fund">Kline Veterans Fund</option>
                <option value="LinkedIn">LinkedIn</option>
                <option value="MCON">MCON</option>
                <option value="MOPH Chapter 711">MOPH Chapter 711</option>
                <option value="MSEP">MSEP</option>
                <option value="Merging Vets and Players">Merging Vets and Players</option>
                <option value="Military Bowl">Military Bowl</option>
                <option value="Military Influencer Conference">Military Influencer Conference</option>
                <option value="Military Makeover">Military Makeover</option>
                <option value="Military Times">Military Times</option>
                <option value="PGA Hope">PGA Hope</option>
                <option value="Professional Bull Riders">Professional Bull Riders</option>
                <option value="Radio">Radio</option>
                <option value="SD Business Journal">SD Business Journal</option>
                <option value="SDMAC">SDMAC</option>
                <option value="SNVCC">SNVCC</option>
                <option value="Student Veterans of America">Student Veterans of America</option>
                <option value="The Hill Summit">The Hill Summit</option>
                <option value="UNLV">UNLV</option>
                <option value="UNLV Rebel Vets">UNLV Rebel Vets</option>
                <option value="US4Warriors">US4Warriors</option>
                <option value="VECA">VECA</option>
                <option value="VFW Post 12198">VFW Post 12198</option>
                <option value="Vegas Chamber">Vegas Chamber</option>
                <option value="Vegas Golden Knights">Vegas Golden Knights</option>
                <option value="Veteran Social Club">Veteran Social Club</option>
                <option value="Veteran Tickets">Veteran Tickets</option>
                <option value="Women Veterans Alliance">Women Veterans Alliance</option>
                <option value="Yahoo">Yahoo</option>
            </select>
        </div>
    );
};

export default LeadSelect;
